import { render, staticRenderFns } from "./SelfieActivity.vue?vue&type=template&id=dc255c0a&scoped=true&"
import script from "./SelfieActivity.vue?vue&type=script&lang=js&"
export * from "./SelfieActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc255c0a",
  null
  
)

export default component.exports